<template style="height: 100%;">
  <div class="zreport">
    <el-button type="primary" @click="dc" class="dc">导出报告</el-button>
    <h2>{{ data.CERI }}</h2>
    <h3>学生心理健康情况报告</h3>
    <div class="div1">
      <p>一、总体概况</p>
      <p>本次心理普查的主要内容是学生的人格特点、一般心理健康状况、抑郁倾向以及自杀态度，分别采用卡特尔16种人格因素测验（16PF）、大学生心理健康问卷（UPI）、抑郁自评量表（SDS）、自杀态度问卷（QSA）进行测试评估。截至{{data.Dates}}，贵单位应参测学生{{ data.StudentCount}}人，实际参测学生{{data.StudentCountSj}}人，其中完成卡特尔16种人格因素测验（16PF）{{data.StudentCount16PF}}人次、完成大学生人格测验（UPI）{{data.StudentCountUPI}}人次、完成抑郁自评量表（SDS）{{data.StudentCountSDS}}人次、完成自杀态度问卷（QSA）{{data.StudentCountQSA}}人次，实际完整参测学生{{ data.StudentCountSjCount }}人，完成比{{data.Sex1CountSjCountZb}}%。</p>
      <p>本次心理普查，参加测试的男生有{{ data.Sex1Count }}人，占参测人数的{{data.Sex1CountZb}}%;参测女生有{{ data.Sex2Count }}人，占参测人数的{{data.Sex2CountZb}}%;如图所示。</p>

      <div class="myChart1" id="myChart" :style="{ width: '300px', height: '300px' }"></div>
      
      <p>本次心理普查，参测硕士研究生有{{ data.EducationYan }}人，占参测人数的{{data.EducationYanZb}}%;参测博士研究生有{{ data.EducationBo }}人，占参测人数的{{data.EducationBoZb}}%;如图所示。</p>
      <div class="myChart1" id="myChart2" :style="{ width: '300px', height: '300px' }"></div>
    </div>
    <div class="div2">
      <p>二、量表情况统计</p>
      <p>（一）总体情况统计</p>
      <p>贵单位参测学生中情绪不稳定的有{{ data.EmoCount }}人，占比{{data.EmoCountZb}}%；心理健康水平低的有{{ data.MentalCount }}人，占比{{data.MentalCountZb}}%；中度以上抑郁的有 {{ data.Depressed }} 人，占比{{data.DepressedZb}}%；共有{{ data.Suicide }}人曾经有过自杀意念，占比{{data.SuicideZb}}%，见下表。</p>
    </div>
    <tbody class="tbody1">
      <thead>
        <tr>
          <td>类别</td>
          <td>人数</td>
          <td>百分比</td>
        </tr>
      </thead>
      <tr>
        <td>情绪不稳定</td>
        <td>{{ data.EmoCount }}</td>
        <td>{{ data.EmoCountZb }}</td>
      </tr>
      <tr>
        <td>心理健康水平低</td>
        <td>{{ data.MentalCount }}</td>
        <td>{{ data.MentalCountZb }}</td>
      </tr>
      <tr>
        <td>中度以上抑郁</td>
        <td>{{ data.Depressed }}</td>
        <td>{{ data.DepressedZb }}</td>
      </tr>
      <tr>
        <td>曾经有过自杀意念</td>
        <td>{{ data.Suicide }}</td>
        <td>{{ data.SuicideZb }}</td>
      </tr>
    </tbody>
    <div class="div3">
      <p>贵单位参测学生整体学生指标对比如下表所示：</p>
    </div>
    <tbody class="tbody1">
      <thead>
        <tr>
          <td>项目</td>
          <td>贵单位情况</td>
          <td>国科大整体情况</td>
        </tr>
      </thead>
      <tr>
        <td>SDSB的平均分</td>
        <td>{{ data.SDSBPJG }}</td>
        <td>{{ data.SDSBPJZ }}</td>
      </tr>
      <tr>
        <td>UPIT的平均分</td>
        <td>{{ data.UPITPJG }}</td>
        <td>{{ data.UPITPJZ }}</td>
      </tr>
      <tr>
        <td>UPIQ25=1的人数</td>
        <td>{{ data.UPIQ25PJG }}</td>
        <td>{{ data.UPIQ25PJZ }}</td>
      </tr>
    </tbody>
    <div class="div3">
      <p>（二）情绪不稳定情况</p>
      <p>
        贵单位情绪不稳定的{{data.EmoCount}}人中，性别分布上，男生{{data.PF16Sex1}}人，女生{{data.PF16Sex0}}人；学历层次分布上，硕士研究生{{data.PF16Degree0}}人，博士研究生{{data.PF16Degree1}}人。各专业情绪不稳定人员情况见下表。
      </p>

      <tbody class="tbody1">
        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>
        <tr  v-for="item in data.PF16List" :key="item">
          <td >{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>
      </tbody>

      <p>（三）心理健康水平低情况</p>

      <p>贵单位心理健康水平低的{{ data.MentalCount }}人中，性别分布上，男生{{data.UPIQ25Sex1}}人，女生{{data.UPIQ25Sex0}}人；学历层次分布上，硕士研究生{{data.UPIQ25Degree0}}人，博士研究生{{data.UPIQ25Degree1}}人。各专业心理健康水平低人员情况见下表。</p>

      <tbody class="tbody1">
        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>
        <tr v-for="item in data.UPILists" :key="item">
          <td >{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>
      </tbody>


      <!-- <tbody class="tbody1">
        <thead>
          <tr>
            <td colspan="2">类目</td>
            <td v-for="item in data.UPILists" :key="item">
              {{item.Specialty}}
            </td>
          </tr>
        </thead>
        <tr>
          <td rowspan="2">性别</td>
          <td>男</td>
          <td v-for="item in data.UPILists" :key="item">{{item.Sex1}}</td>
        </tr>
        <tr>
          <td>女</td>
          <td v-for="item in data.UPILists" :key="item">{{item.Sex0}}</td>
        </tr>
        <tr>
          <td rowspan="2">学历层次</td>
          <td>硕士研究生</td>
          <td v-for="item in data.UPILists" :key="item">{{item.Degree1}}</td>
        </tr>
        <tr>
          <td>博士研究生</td>
          <td v-for="item in data.UPILists" :key="item">{{item.Degree2}}</td>
        </tr>
      </tbody> -->

      <p>（四）中度以上抑郁情况</p>

      <p>贵单位中度以上抑郁的{{data.Depressed}}人中，性别分布上，男生{{data.SDSSex1}}人，女生{{data.SDSSex0}}人；学历层次分布上，硕士研究生{{data.SDSDegree0}}人，博士研究生{{data.SDSDegree1}}人。各专业中度以上抑郁人员情况见下表
      </p>

      <tbody class="tbody1">
        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>
        <tr v-for="item in data.SDSLists" :key="item">
          <td >{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>
      </tbody>

      <!-- <tbody class="tbody1">
        <thead>
          <tr>
            <td colspan="2">类目</td>
            <td v-for="item in data.SDSLists" :key="item">{{item.Specialty}}</td>
          </tr>
        </thead>

        <tr>
          <td rowspan="2">性别</td>
          <td>男</td>
          <td v-for="item in data.SDSLists" :key="item">{{ item.Sex1 }}</td>
        </tr>

        <tr>
          <td>女</td>
          <td v-for="item in data.SDSLists" :key="item">{{ item.Sex0 }}</td>
        </tr>

        <tr>
          <td rowspan="2">学历层次</td>
          <td>硕士研究生</td>
          <td v-for="item in data.SDSLists" :key="item">{{ item.Degree1 }}</td>
        </tr>

        <tr>
          <td>博士研究生</td>
          <td v-for="item in data.SDSLists" :key="item">{{ item.Degree2 }}</td>
        </tr>
      </tbody> -->

      <p>（五）曾经有过自杀意念情况</p>
      <p>贵单位曾经有过自杀意念的{{ data.Suicide }}人中，性别分布上，男生{{data.QSASex1}}人，女生{{ data.QSASex0 }}人；学历层次分布上，硕士研究生{{data.QSADegree0}}人，博士研究生{{ data.QSADegree1 }}人。各专业曾经有过自杀意念人员情况见下表。
      </p>
      <tbody class="tbody1">

        <thead>
          <tr>
            <th>类目</th>
            <th colspan="2">学历层次</th>
            <th colspan="2">性别</th>
          </tr>
        </thead>

        <tr>
          <td></td>
          <td>硕士研究生</td>
          <td>博士研究生</td>
          <td>男</td>
          <td>女</td>
        </tr>

        <tr  v-for="item in data.QSALists" :key="item">
          <td>{{item.Specialty}}</td>
          <td>{{item.Degree1}}</td>
          <td>{{item.Degree2}}</td>
          <td>{{item.Sex1}}</td>
          <td>{{item.Sex0}}</td>
        </tr>

      </tbody>
      <!-- <tbody class="tbody1">
        <thead>
          <tr>
            <td colspan="2">类目</td>
            <td v-for="item in data.QSALists" :key="item">
              {{ item.Specialty }}
            </td>
          </tr>
        </thead>
        <tr>
          <td rowspan="2">性别</td>
          <td>男</td>
          <td v-for="item in data.QSALists" :key="item">{{ item.Sex1 }}</td>
        </tr>
        <tr>
          <td>女</td>
          <td v-for="item in data.QSALists" :key="item">{{ item.Sex0 }}</td>
        </tr>
        <tr>
          <td rowspan="2">学历层次</td>
          <td>硕士研究生</td>
          <td v-for="item in data.QSALists" :key="item">{{ item.Degree1 }}</td>
        </tr>
        <tr>
          <td>博士研究生</td>
          <td v-for="item in data.QSALists" :key="item">{{ item.Degree2 }}</td>
        </tr>
      </tbody> -->
      <p>三、综合排查结果</p>
      <p>本次心理普查综合排查划分四个等级，各等级划分标准及处理建议和措施见下表：</p>
      <tbody>
        <thead>
          <tr>
            <td style="width: 120px;">风险等级</td>
            <td>风险标准</td>
            <td style="width: 120px;">处理等级</td>
            <td style="width: 800px;">建议措施</td>
          </tr>
        </thead>
        <tr>
          <td style="width: 120px;">重度</td>
          <td>满足以下任一条件：<br />1.SDS≥70<br />2.SDS≥70并且UPIQ25=1</td>
          <td style="width: 120px;">密切陪护</td>
          <td style="width: 800px; text-align: left; padding: 10px;">
            心理辅导员或心理咨询师须及时与当事人谈心谈话，引导当事人就医或接受专业人员帮助，初步评估并向心理中心报告。如情况属实（症状显著，确有自杀计划或自杀未遂，仅有自杀意念可以列为中等），须及时密切陪护（至少两名同性别人员24小时陪护），联系监护人及时到场，及时转介就医。
            
          </td>
        </tr>
        <tr>
          <td style="width: 120px;">中度</td>
          <td>满足以下任一条件：<br />1.70>SDS≥60<br />2.UPIQ25=1</td>
          <td style="width: 120px;">重点关注</td>
          <td style="width: 800px; text-align: left; padding: 10px;">
            心理辅导员应及时与当事人谈心谈话，引导当事人接受专业人员帮助，初步评估（是否有自杀计划，是否有精神障碍诊断）并向心理中心报告。如情况属实（排除自杀计划和严重精神障碍诊断，有长期内心冲突或人际关系不良），建议当事人预约心理咨询或就医诊断治疗，须重点关注（每周谈心谈话一次），及时与监护人联系了解情况并告知现状。
          </td>
        </tr>
        <tr>
          <td style="width: 120px;">轻度</td>
          <td>60>SDS≥50且UPIQ25=0</td>
          <td style="width: 120px;">适当关注</td>
          <td style="width: 800px; text-align: left; padding: 10px;">心理辅导员应适时与当事人谈心谈话，给予心理辅导，予以适当关注（每两周谈心谈话一次），找到监护人的联系方式，以便必要时可以及时沟通情况。</td>
        </tr>
        <tr>
          <td style="width: 120px;">良好</td>
          <td>不满足以上任一条件</td>
          <td style="width: 120px;">无</td>
          <td style="width: 800px; text-align: left; padding: 10px;">无特别建议，保持正常的交流沟通即可。</td>
        </tr>
      </tbody>
      <p>注：心理测量只作为评估辅助工具，且为当事人主观填写，测量结果仅供参考，请结合实际情况进行综合评估与使用。</p>
      <p>贵单位本次心理普查综合排查中，划分为重度风险{{data.Severe}}人，占比{{data.SevereZB}}%；划分为中度风险{{data.Moderate}}人，占比{{data.ModerateZB}}%；划分为轻度风险{{data.Mild}}人，占比{{data.MildZB}}%；划分为良好{{data.Good}}人，占比{{data.GoodZB}}%。综合排查风险等级情况见下图。
      </p>
    </div>
    <div class="myChart1" id="myChart3" :style="{width:'300px',height:'300px'}"></div>
    <p>在本次综合排查中，重度风险中男生{{data.SevereSex1}}人，女生{{data.SevereSex0}}人；中度风险中男生{{data.ModerateSex1}}人，女生{{data.ModerateSex0}}人；轻度风险中男生{{data.MildSex1}}人，女生{{data.MildSex0}}人，分布如下图所示。</p>
    <div class="myChart1" id="myChart4" :style="{width:'600px',height:'400px'}"></div>
    <p>在本次综合排查中，重度风险中硕士研究生{{data.SevereDegree0}}人，博士研究生{{data.SevereDegree1}}人；中度风险中硕士研究生{{data.ModerateDegree0}}人，博士研究生{{data.ModerateDegree1}}人；低度风险中硕士研究生{{data.MildDegree0}}人，博士研究生{{data.MildDegree1}}人，分布如下图所示。
    </p>
    <div class="myChart1" id="myChart5" :style="{width:'600px',height:'400px'}"></div>
    <div class="div4">
      <h5>综合排查名单</h5>
      <p>1、重度风险人员：风险人数：{{data.Severe}}人，预警比例：{{data.SevereZB}}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:180px;">学历层次</td>
            <td style="width:800px;">抑郁自评量表（SDS）标准分</td>
            <td style="width:180px;">UPIQ25值</td>
          </tr>
        </thead>

        <tr v-for="(item, i) in data.SevereTableList" :key="i">
          <td>{{i + 1}}</td>
          <td>{{item.UserID}}</td>
          <td>{{item.Sex}}</td>
          <td>{{item.Degree}}</td>
          <td>{{item.PaperScoreS}}</td>
          <td>{{item.AnswerScore}}</td>
        </tr>
      </tbody>
      <p>2、中度风险人员：风险人数：{{data.Moderate}}人，预警比例：{{data.ModerateZB}}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:180px;">学历层次</td>
            <td style="width:800px;">抑郁自评量表（SDS）标准分</td>
            <td style="width:180px;">UPIQ25值</td>
          </tr>
        </thead>
        <tr v-for="(item, i) in data.ModerateTableList" :key="i">
          <td>{{i + 1}}</td>
          <td>{{item.UserID}}</td>
          <td>{{item.Sex}}</td>
          <td>{{item.Degree}}</td>
          <td>{{item.PaperScoreS}}</td>
          <td>{{item.AnswerScore}}</td>
        </tr>
      </tbody>
      <p>3、轻度风险人员：风险人数：{{data.Mild}}人，预警比例：{{data.MildZB}}%。</p>
      <tbody>
        <thead>
          <tr>
            <td style="width:120px;">序号</td>
            <td style="width:220px;">学号</td>
            <td style="width:180px;">性别</td>
            <td style="width:180px;">学历层次</td>
            <td style="width:800px;">抑郁自评量表（SDS）标准分</td>
            <td style="width:180px;">UPIQ25值</td>
          </tr>
        </thead>
        <tr v-for="(item, i) in data.MildTableList" :key="i">
          <td>{{i + 1}}</td>
          <td>{{item.UserID}}</td>
          <td>{{item.Sex}}</td>
          <td>{{item.Degree}}</td>
          <td>{{item.PaperScoreS}}</td>
          <td>{{item.AnswerScore}}</td>
        </tr>
      </tbody>
      <!-- <p class="zp">
        注：心理测量只作为诊断评估辅助工具，测量结果仅供参考，请结合实际情况进行评估。
      </p> -->
    </div>
    <div class="dis" v-if="dis">
        <div class="dis-s" style="text-align: center;">
            <img style="width: 200px;height: 200px;" src="../../../assets/4092865.gif" alt="">
            <p style="font-size: 18px;">数据加载中，请稍等...</p>
        </div>
      </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PaperResultID: '',
      ReportType: '',
      dis: true,

      data: '',
      DeptID: '',
      NianJI: '',
    }
  },
  methods: {
    t1() {

      let myChart = this.$echarts.init(document.getElementById('myChart'));

      myChart.setOption({
        tooltip : {
            trigger: 'item',
            // formatter: "{b} : {c} ({d}%)",


            formatter: function(data){
              return (
                "性别："+data['name']
                +"</br>人数: "+ data['data'].shum
                + "</br>占比："+data['data'].value+"%"
              )
            }


        },
        color: ['#fac090', '#4473b9'],
        series: [
          {
            type: 'pie',
            radius: '50%',
            // data: this.data.RosesSex,
            data: [
              {value: this.data.Sex2CountZb, name: "女生",shum: this.data.Sex2Count},
              {value: this.data.Sex1CountZb, name: "男生",shum: this.data.Sex1Count}
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'}
              }
            }
          ],
      })
    },


    t2() {
      let myChart2 = this.$echarts.init(document.getElementById('myChart2'));
      myChart2.setOption({
        tooltip: { trigger: 'item',
        formatter: function(data){
              return (
                "性别："+data['name']
                +"</br>人数: "+ data['data'].shum
                + "</br>占比："+data['data'].value+"%"
              )
            }
        
        },
        color: ['#4473b9', '#ed7d31'],
        series: [{
          type: 'pie',
          radius: '50%',
          data: [
            {value: this.data.EducationYanZb, name: "硕士研究生",shum: this.data.EducationYan},
            {value: this.data.EducationBoZb, name: "博士研究生",shum: this.data.EducationBo}
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,shadowOffsetX: 0,shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }}
        ],
      })
    },

    t3() {
      let myChart3 = this.$echarts.init(document.getElementById('myChart3'));
      myChart3.setOption({tooltip:{trigger:'item'},
      series: [{type:'pie',radius:'50%',data:this.data.RosesType,emphasis:{itemStyle:{shadowBlur: 10,shadowOffsetX: 0,shadowColor:'rgba(0, 0, 0, 0.5)'}}}]})
    },
    t4() {
      let myChart4 = this.$echarts.init(document.getElementById('myChart4'));
      myChart4.setOption({
        tooltip: {trigger:'axis',axisPointer:{type:'shadow'}},
        color: ['#fac090','#4473b9'],
        legend: {},
        grid: {left:'3%',right:'4%',bottom:'3%',containLabel:true},
        xAxis: {type:'category',data:this.data.SexHistogramTyoe},
        yAxis: {type:'value' },
        series: [{name:'男',type:'bar',data:this.data.Sex1Histogram},{name: '女',type: 'bar', data: this.data.Sex0Histogram}],
      })
    },
    t5(){
      let myChart5 = this.$echarts.init(document.getElementById('myChart5'));
      myChart5.setOption({
        tooltip: {trigger:'axis',axisPointer:{type:'shadow'}},
        color: ['#4473b9','#ed7d31'],
        legend: {},
        grid: {left:'3%',right:'4%',bottom:'3%',containLabel: true},
        xAxis: {type:'category',data:this.data.SexHistogramTyoe},
        yAxis: {type:'value'},
        series: [{name:'硕士研究生',type:'bar',data:this.data.Degree0Histogram},{name:'博士研究生',type:'bar',data:this.data.Degree1Histogram}]})
    },
    dc() {
      this.$Http_Post('ScaleIssue/GetMentalHealthWord', {PublishID: this.PaperResultID[0], ReportType: this.ReportType[0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          window.location = res.Data;
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    },
  },
  mounted() {
    this.PaperResultID = [this.$route.query.PaperResultID];
    this.ReportType = [this.$route.query.ReportType];
    this.DeptID = [this.$route.query.DeptID];
    this.NianJI = [this.$route.query.NianJI];
    this.$Http_Post('ScaleIssue/GetMentalHealth',{ ReportType: this.ReportType[0], PublishID: this.PaperResultID[0],DeptID:[this.$route.query.DeptID][0],NianJI:[this.$route.query.NianJI][0]}).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data;
        this.dis = false;
        this.t1();
        this.t2();
        this.t3();
        this.t4();
        this.t5();
      } else {
        this.Global.request_failure(res.Message);
      }
    })
  },
}
</script>
<style>
.zreport .dis{background-color: #fff;width: 100%;height: 100%;position: fixed;top:0px;left: 0px;}
.zreport .dis .dis-s{width: 500px;height: 500px;position: absolute;top: 0;left: 0;right: 0;bottom: 0;margin: auto;}
.zreport {width: 1200px;margin: 0 auto;}
.zreport h1,h2,h3,h4,h5,h6,h7 {text-align: center;margin-top: 20px;}
.zreport h3 {font-size: 20px;}
.zreport .div1 p {font-size: 16px;line-height: 30px;margin-top: 10px;}
.zreport .div1 p:nth-child(2) {text-indent: 2em;}
.zreport .div1 p:nth-child(3) {text-indent: 2em;}
.zreport .myChart1 {width: 200px;height: 200px;margin: 0 auto;}
.zreport .div2 p {font-size: 16px;line-height: 30px;margin-top: 10px;}
.zreport .div2 p:nth-child(2) {text-indent: 2em;}
.zreport tbody {width: 500px;margin-top: 20px;display: inline-block;margin-left: 20%;margin-top: 40px;}
.zreport tbody tr {height: 50px;line-height: 50px;text-align: center;}
.zreport tbody td {height: 50px;line-height: 50px;text-align: center;}
.zreport .tbody1 tr {height: 50px;line-height: 50px;text-align: center;min-width: 200px;}
.zreport .tbody1 td {height: 50px;line-height: 50px;text-align: center;min-width: 200px;}
.zreport .div3 {margin-top: 40px;}
.zreport .div3 p {font-size: 16px;line-height: 30px;margin-top: 10px;}
.zreport thead {background-color: bisque;}
.zreport .div3 tbody {margin-left: 50px;width: 1100px;}
.zreport .div3 tbody tr {height: 50px;line-height: 34px;text-align: center;width: 200px;}
.zreport .div3 tbody td {height: 50px;line-height: 34px;text-align: center;width: 200px;}
.zreport .div4 tbody {margin-left: 50px;width: 1100px;}
.zreport .div4 p {margin-top: 40px;}
.zp {padding-bottom: 60px;color: red;}
.zreport .div4 h5 {font-size: 20px;}
.dc {position: fixed;top: 20px;right: 10px;}
#myChart4 {margin-top: 20px;}
#myChart5 {margin-top: 20px;}
.zreport thead th{background-color: bisque !important;color: #3a3a3a;}
</style>
